import { api } from "./api";

export const trackEvent = async (name, caseIdOrData, dataOrNothing) => {
  const caseId = dataOrNothing == null ? undefined : caseIdOrData;
  const data = (dataOrNothing == null ? caseIdOrData : dataOrNothing) || {};

  await api.post("/tracking_event", { name, data, case_id: caseId });
};
